var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RequestError } from '../error';
import { eventbus } from '../event';
/** 接口返回成功时的 code */
var XHR_CODE_SUCCESS = 1;
/**
 * 发起 HTTP 请求
 * @param url 请求链接
 * @param options 请求链接
 */
export function request(url, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var meta = {
        url: url,
        context: options.context,
        globalError: (_a = options.globalError) !== null && _a !== void 0 ? _a : true,
        options: options,
    };
    if ('context' in options) {
        delete options.context;
    }
    if ('globalError' in options) {
        delete options.globalError;
    }
    eventbus.emit('ajax:begin', { meta: meta });
    var _b = options.method, method = _b === void 0 ? 'GET' : _b;
    var headers = __assign({}, options.headers);
    var body;
    if (['PUT', 'POST', 'DELETE'].includes(method)) {
        if (options.body instanceof FormData) {
            // form data
            body = options.body;
        }
        else {
            headers = __assign({ 'Content-Type': 'application/json; charset=utf-8' }, options.headers);
            if (typeof options.body === 'object') {
                // serialize json object
                body = JSON.stringify(options.body);
            }
            else {
                // string
                body = options.body;
            }
        }
    }
    var promise = new Promise(function (resolve, reject) {
        var _a, _b;
        var xhr = new XMLHttpRequest();
        xhr.open(method, meta.url, true);
        Object.keys(headers).forEach(function (key) {
            if (headers[key]) {
                xhr.setRequestHeader(key, headers[key]);
            }
        });
        xhr.withCredentials = (_a = options.withCredentials) !== null && _a !== void 0 ? _a : true;
        xhr.timeout = (_b = options.timeout) !== null && _b !== void 0 ? _b : 10000;
        xhr.onload = function () {
            var _a;
            try {
                var status_1 = xhr.status, responseText = xhr.responseText;
                var resp = JSON.parse(responseText) || {};
                if (status_1 >= 200 && status_1 < 300) {
                    eventbus.emit('ajax:load-success', { resp: resp, meta: meta });
                    var code = (resp === null || resp === void 0 ? void 0 : resp.code) || -1;
                    if (code === XHR_CODE_SUCCESS) {
                        resolve(resp.data);
                    }
                    else {
                        // 和服务端约定，客户端只展示 code > 1 时服务端返回的错误消息
                        var message = code < XHR_CODE_SUCCESS ? '服务端错误' : resp.message || '未知错误';
                        var error = RequestError.create({ message: message, code: code });
                        error.detail = __assign(__assign({}, resp), { status: status_1 });
                        reject(error);
                    }
                }
                else if (status_1 >= 400 && status_1 < 500) {
                    var error = RequestError.create(RequestError.CLIENT_ERROR);
                    error.detail = __assign(__assign({}, resp), { status: status_1 });
                    reject(error);
                }
                else {
                    var error = RequestError.create(RequestError.SERVER_ERROR);
                    error.detail = __assign(__assign({}, resp), { status: status_1 });
                    reject(error);
                }
            }
            catch (err) {
                var error = new Error('系统异常，请稍后再试');
                var status_2 = xhr.status, responseText = xhr.responseText;
                error['detail'] = { status: status_2, responseText: responseText, message: (_a = err) === null || _a === void 0 ? void 0 : _a.message };
                reject(error);
            }
        };
        xhr.onerror = function () {
            reject(RequestError.create(RequestError.NETWORK_ERROR));
        };
        xhr.ontimeout = function () {
            reject(RequestError.create(RequestError.TIMEOUT_ERROR));
        };
        xhr.send(body || null);
    });
    return promise
        .then(function (data) {
        eventbus.emit('ajax:success', { data: data, meta: meta });
        return data;
    }, function (error) {
        eventbus.emit('ajax:error', { error: error, meta: meta });
        throw error;
    })
        .finally(function () {
        eventbus.emit('ajax:end', { meta: meta });
    });
}
